import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatDialogModule } from '@angular/material/dialog';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
    selector: 'app-footer',
    standalone: true,
    imports: [
        RouterModule,
        CommonModule,
        MatDialogModule,
        MatMenuModule,
        MatButtonModule,
        MatIconModule,
        TranslateModule,
        MatTooltipModule,
    ],
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.sass',
})
export class FooterComponent {
    currentYear: number = new Date().getFullYear();
}
